/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface UpdateDeviceStateDto
 */
export interface UpdateDeviceStateDto {
  /**
   * Enum indicating the new state of the device
   *
   * @type {string}
   * @memberof UpdateDeviceStateDto
   * @example enabled
   */
  device_state: UpdateDeviceStateDtoDeviceStateEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateDeviceStateDtoDeviceStateEnum {
  Created = 'created',
  Producing = 'producing',
  Validation = 'validation',
  Packaging = 'packaging',
  Enabled = 'enabled',
  PendingShipment = 'pending_shipment',
  PickedUp = 'picked_up',
  Rented = 'rented',
  Purchased = 'purchased',
  Substitution = 'substitution',
  Maintenance = 'maintenance',
  Disabled = 'disabled',
}
